<template>
  <div class="info-health">
    <HeroBanner
        :background-image="bannerImage"
        title="건강 정보"
        sub-title="귀 건강을 지키는 생활 습관과 <br>
        청력 관리에 도움되는 소식을 알려드립니다."
    />
    <BoardList
      :boards="boards"
      :loading="loading"
      detail-path="/information/health"
      :show-search="true"
      :show-more-button="hasMore"
      :show-list-thumbnail="true"
      :hide-type-badge="true"
      @search="handleSearch"
      @load-more="loadMoreBoards"
    />
  </div>
</template>

<script>
import HeroBanner from "@/components/HeroBanner.vue";
import BoardList from "@/components/BoardList.vue";
import boardListMixin from '@/mixins/boardListMixin';
import { fetchHealthInfoList } from '@/api';
import bannerBg from '@/assets/images/heros/05-top-img.png';
import bannerBg2 from '@/assets/images/heros/05-top-img@2x.png';

export default {
  name: 'InfoHealth',
  components: {HeroBanner, BoardList},
  mixins: [boardListMixin],
  data() {
    return {
      bannerImage: [bannerBg, bannerBg2],
      boardPath: '/information/health'
    };
  },
  methods: {
    fetchAPI(params) {
      return fetchHealthInfoList(params);
    },
    mapBoardRow(board) {
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'];
      let thumbnailUrl = null;
      const list = board.attachments || [];
      const mainAtt = list.find((a) => a.type === 'main');
      if (mainAtt && mainAtt.download_url && mainAtt.originalname) {
        const ext = mainAtt.originalname
          .substring(mainAtt.originalname.lastIndexOf('.'))
          .toLowerCase();
        if (imageExtensions.includes(ext)) {
          thumbnailUrl = mainAtt.download_url;
        }
      }
      return { ...board, thumbnailUrl };
    }
  }
};
</script>

<style scoped lang="scss">
.info-health {
  width: 100%;
  min-height: 55px;
}
</style>
